window.theme = window.theme || {};

theme.deliveryEstimate = (function () {
  var TIMEZONE = 'Europe/Copenhagen';
  var CUTOFF_HOUR = 15;

  // Reads the current wall-clock date/time as it actually is in
  // Europe/Copenhagen right now, regardless of the visitor's own device
  // timezone or the browser's local clock settings — this is what the
  // previous version got wrong (it always used the browser's local
  // Date methods, which silently follow whatever timezone the visitor's
  // device happens to be set to, not Copenhagen).
  function getCopenhagenParts(date) {
    var formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: TIMEZONE,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      hour12: false
    });

    var parts = {};
    formatter.formatToParts(date).forEach(function (part) {
      if (part.type !== 'literal') {
        parts[part.type] = parseInt(part.value, 10);
      }
    });

    // Some engines report midnight as hour 24 with hour12:false.
    if (parts.hour === 24) {
      parts.hour = 0;
    }

    return parts;
  }

  function addBusinessDays(baseDate, days) {
    var result = new Date(baseDate.getTime());
    var added = 0;
    while (added < days) {
      result.setUTCDate(result.getUTCDate() + 1);
      var day = result.getUTCDay();
      if (day !== 0 && day !== 6) {
        added++;
      }
    }
    return result;
  }

  function getEstimatedDate(now) {
    var parts = getCopenhagenParts(now || new Date());

    // A neutral, timezone-independent anchor for the day-arithmetic below:
    // Copenhagen's current calendar date, held as UTC midnight purely so
    // setUTCDate/getUTCDay never get reinterpreted through the browser's
    // own local timezone (which previously caused the whole calculation
    // to silently run in whatever zone the visitor's device was in).
    var baseDate = new Date(Date.UTC(parts.year, parts.month - 1, parts.day));
    var weekday = baseDate.getUTCDay();
    var isWeekend = weekday === 0 || weekday === 6;
    var isPastCutoff = parts.hour >= CUTOFF_HOUR;

    // Before 15:00 on a weekday: next business day. On/after 15:00, or on
    // a weekend (order can't be processed until Monday, which itself is
    // then treated as already past its own effective cutoff): the
    // business day after that. This single rule covers every case in the
    // spec, including Friday (which needs no special-casing — "before
    // 15:00 Friday" naturally lands on Monday, "at/after 15:00 Friday" on
    // Tuesday, purely from skipping the weekend while adding 1 vs 2 days).
    var daysToAdd = (isWeekend || isPastCutoff) ? 2 : 1;

    return addBusinessDays(baseDate, daysToAdd);
  }

  function getFormattedDate() {
    var estimated = getEstimatedDate();
    // timeZone: 'UTC' here matches how estimated was built (Date.UTC) —
    // formatting it in the browser's local zone instead could shift the
    // displayed calendar date by a day depending on the visitor's offset.
    // da-DK already formats the weekday and month lowercase, matching
    // Danish convention (unlike English, weekdays/months aren't
    // capitalized) — no case adjustment needed.
    return estimated.toLocaleDateString('da-DK', {
      timeZone: 'UTC',
      weekday: 'long',
      day: 'numeric',
      month: 'long'
    });
  }

  function renderAll() {
    var formatted = getFormattedDate();
    document.querySelectorAll('[data-delivery-date-text]').forEach(function (el) {
      el.textContent = formatted;
    });
  }

  // Product page only: hide the delivery-estimate block whenever the
  // currently selected variant is unavailable, and show it again once an
  // available variant is selected. Uses the theme's own 'variant:change'
  // event (the same source of truth the buy button and inventory status
  // already rely on) — no separate variant-tracking logic, no page reload.
  function updateProductPageAvailability(variant) {
    var wrapper = document.querySelector('[data-delivery-estimate-wrapper]');
    if (!wrapper) return;
    var available = !!(variant && variant.available);
    wrapper.style.display = available ? '' : 'none';
  }

  document.addEventListener('variant:change', function (evt) {
    updateProductPageAvailability(evt.detail && evt.detail.variant);
  });

  document.addEventListener('DOMContentLoaded', renderAll);
  document.addEventListener('shopify:section:load', renderAll);

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    renderAll();
  }

  return {
    renderAll: renderAll,
    getFormattedDate: getFormattedDate
  };
})();
